<template>
    <!-- 对我感兴趣的 -->
    <div class="col-chart-box">
        <div class="col-chart-head line">
            <div class="left">
                <div class="left-title">对我感兴趣的采购</div>
                <!-- <el-popover 
                    content="合作采购数，合作授盘金额越大，显示的字体越大" 
                    placement="right"
                    trigger="hover"
                    width="300">
                    <i slot="reference" class="iconfont icon-icon-zhuming2"></i>
                </el-popover> -->
            </div>
        </div>
        <div v-loading="loading" class="col-chart-view" v-if="$store.state.userInfo.leadsStatus==7&&$store.state.userInfo.isMember ==1">
            <wordcloud
                v-if="dockBuyerData.length"
                class="col-chart-view wordcloud-view"
                :data="wordList"
                nameKey="name"
                valueKey="value"
                :fontSize="[10, 20]"
                :rotate="{to: 0, from:0}"
                :color="['#9661BC','#F6903D','#008685','#F08BB4','#5B8FF9','#CDDDFD','#61DDAA','#CDF3E4','#65789B','#CED4DE','#F6BD16','#FCEBB9','#7262fd','#D3CEFD','#78D3F8']"
                :maxZnStringNum="20"
                :maxEnStringNum="40"
                :showTooltip="true"
                :wordClick="wordClickHandler"
            ></wordcloud>

            <NoDataAutoHeight v-else />
        </div>
      
        <div class="col-chart-content" v-if="$store.state.userInfo.leadsStatus!=7 || $store.state.userInfo.isMember !=1">
            <div class="col-chart-content-img">
                <img src="@/assets/image/common/dataAssistant.png" alt>
            </div>
            <div class="col-chart-content-intro">升级会员享有此服务</div>
        </div>
    </div>
</template>

<script >
import wordcloud from 'hazol-vue-wordcloud/src/index.js';
import {  getDataAssistant } from "@/utils/api/dashboard";
import NoDataAutoHeight from '@/components/NoData-autoHeight.vue';

export default  {
    props:{
        startTime:{
            typeof:String,
            default:''
        },
        endTime:{
            typeof:String,
            default:''
        },
    },
    components: {
        wordcloud,
        NoDataAutoHeight
    },
    data(){
        return {
            loading: false,
            show: false,
            wordList:  [],
            dockBuyerData:[]
        }
    },
    watch: {
        startTime: {
            handler(newVal) {
                if(newVal && this.$store.state.userInfo.leadsStatus==7) {
                    this.getDockBuyerData()
                }
            },
        }
    },
    methods:{
        wordClickHandler(name,value,vm){
            // console.log(name,value,vm)
        },
        //获取各数据列表的数据
        getDockBuyerData(){
            this.loading = true;
            const params = {
                startDate: this.startTime,
                endDate: this.endTime,
                enums:['INTERESTED']
            }
            getDataAssistant(params)
            .then((res)=>{
                const bizCode = res.rspResult.bizCode;
                const codeArr = [401, 403, 404];
                if(bizCode === 200){
                    this.dockBuyerData = res.data.interested || [];
                    this.adddockBuyerData()
                    this.loading = false;
                }else if (!codeArr.includes(bizCode)) {
                    this.loading = false;
                    this.$message.error(res.data.rspResult.message);
                }
            })
            .catch((err)=>{
                this.loading = false;
                this.$message.error("System error",err);
            })
        },
        init(currentData) {
            this.wordList = currentData;
            this.show = true;
        },
        handleDockBuyerData(list) {
            let tmp=  [];
            list.forEach((item, index) => {
                tmp.push({
                    name: item.compName,
                    value: (index + 1) * 2,
                    // id: item.compId
                })
            });
            if(list.length == '1') {
               tmp.push({
                   name: '',
                   value: 0
               }) 
            }
            return tmp;
        },
        adddockBuyerData() {
            if(this.dockBuyerData.length){
                const handledData = this.handleDockBuyerData(this.dockBuyerData.reverse());
                this.init(handledData);
            }
        },
        
       
    },
    mounted() {
        if(this.$store.state.userInfo.leadsStatus==7){
            this.getDockBuyerData()
        }
        const ele=  this.$refs.box;
    },
}
</script>

<style lang="scss" scoped>
.col-chart-view {
    height: 260px;
}
div.tooltip {
    font-size: 14px;
    line-height: 18px;
}

</style>